<template>
  <main class="city-container city-skel">
    <header class="sk-hero">
      <div class="sk-hero-top">
        <div class="sk-head">
          <div class="sk sk-line sk-country" />
          <div class="sk sk-line sk-title" />
          <div class="sk-tags">
            <div class="sk sk-chip" /><div class="sk sk-chip" /><div class="sk sk-chip" />
          </div>
        </div>
        <div class="sk sk-score" />
      </div>
      <div class="sk-gallery">
        <div class="sk sk-gcell sk-gcell--lg" />
        <div class="sk-gcol">
          <div class="sk sk-gcell" /><div class="sk sk-gcell" />
        </div>
      </div>
    </header>
    <div class="sk-layout">
      <aside class="sk-side">
        <div class="sk sk-side-card" v-for="i in 4" :key="'sn-' + i" />
      </aside>
      <div class="sk-main">
        <div class="sk sk-block" />
        <div class="sk sk-block sk-block--short" />
        <div class="sk-rows">
          <div class="sk sk-line" /><div class="sk sk-line" /><div class="sk sk-line sk-line--w60" />
        </div>
        <div class="sk sk-block sk-block--mid" />
        <div class="sk-rows">
          <div class="sk sk-line" /><div class="sk sk-line sk-line--w70" />
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default { name: "CityPageSkeleton" };
</script>

<style scoped>
.city-skel {
  padding-top: 108px;
  padding-bottom: 48px;
}
.sk-hero {
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 20px 24px;
}
.sk-hero-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 20px;
}
.sk-head {
  flex: 1;
  min-width: 0;
}
.sk-country {
  width: 140px;
  height: 14px;
  margin-bottom: 12px;
}
.sk-title {
  width: min(420px, 70%);
  height: 36px;
  margin-bottom: 14px;
  border-radius: 10px;
}
.sk-tags {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.sk-chip {
  width: 76px;
  height: 28px;
  border-radius: 999px;
}
.sk-score {
  width: 72px;
  height: 72px;
  border-radius: 16px;
  flex-shrink: 0;
}
.sk-gallery {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 12px;
  min-height: 280px;
}
@media (max-width: 720px) {
  .sk-gallery {
    grid-template-columns: 1fr;
  }
  .sk-hero-top {
    flex-direction: column;
  }
  .sk-score {
    align-self: flex-start;
  }
}
.sk-gcell {
  height: 134px;
  border-radius: 14px;
}
.sk-gcell--lg {
  height: 100%;
  min-height: 280px;
}
.sk-gcol {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.sk-layout {
  display: grid;
  grid-template-columns: 260px 1fr;
  gap: 28px;
  max-width: 1180px;
  margin: 0 auto;
  padding: 28px 20px 0;
}
@media (max-width: 960px) {
  .sk-layout {
    grid-template-columns: 1fr;
  }
}
.sk-side-card {
  height: 120px;
  border-radius: 14px;
  margin-bottom: 14px;
}
.sk-main {
  min-width: 0;
}
.sk-block {
  height: 140px;
  border-radius: 16px;
  margin-bottom: 20px;
}
.sk-block--short {
  height: 100px;
}
.sk-block--mid {
  height: 180px;
}
.sk-rows .sk-line {
  height: 12px;
  margin-bottom: 10px;
  width: 95%;
}
.sk-line--w60 {
  width: 60%;
}
.sk-line--w70 {
  width: 70%;
}
</style>
